import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from 'src/app/lib/base-page';

@Component({
  selector: 'app-newsfeed-intro',
  templateUrl: './newsfeed-intro.page.html',
  styleUrls: ['./newsfeed-intro.page.scss'],
})
export class NewsfeedIntroPage extends BasePage implements OnInit {


  constructor(private router: Router) {
    super()
   }

  ngOnInit() {
  }

  goToNews(){
    if(this.mobile){
      this.router.navigate(['/tabs/newsfeed'], { replaceUrl: true })
    }else{
      this.router.navigate(['/newsfeed'], { replaceUrl: true })
    }
  }

}
